import type { FC, ReactNode } from 'react'

import dynamic from 'next/dynamic'
import { useEffect, useState } from 'react'
import ErrorBoundary from '@/components/generals/error-boundary'
import DoorDrawing from '@/components/configurator/door-drawing'
import { DEFAULT_CONFIG } from '@/lib/configurator/options'
import { normalizeConfig } from '@/lib/configurator/validate'

const DoorScene = dynamic(() => import('@/components/configurator/door-scene'), {
    ssr: false,
    loading: () => <div className='h-full w-full animate-pulse bg-[#d9d7d3]' />
})

export const SHOWCASE_DOOR = normalizeConfig({
    ...DEFAULT_CONFIG,
    doorType: 'draaideur',
    width: 980,
    height: 2400,
    division: 'raster',
    rows: 3,
    cols: 1,
    glass: 'helder',
    finish: 'ral9005',
    profile: 'slank',
    handle: 'lang',
    handleFinish: 'zwart',
    sidePanels: 'rechts',
    sidePanelWidth: 420
})

const HeroDoor: FC = (): ReactNode => {
    const [open, setOpen] = useState(false)
    const [motion, setMotion] = useState(true)

    useEffect(() => {
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches

        setMotion(!reduced)

        if (reduced) return

        const timer = window.setInterval(() => setOpen(value => !value), 4200)

        return () => window.clearInterval(timer)
    }, [])

    return (
        <ErrorBoundary
            fallback={(
                <div className='flex h-full items-center justify-center bg-[#d9d7d3] p-10'>
                    <DoorDrawing config={SHOWCASE_DOOR} className='max-h-full w-auto' />
                </div>
            )}
        >
            <DoorScene
                config={SHOWCASE_DOOR}
                open={open}
                view='voor'
                showDimensions={false}
                onToggleOpen={() => setOpen(value => !value)}
                mode='showcase'
                motion={motion}
            />
        </ErrorBoundary>
    )
}

export default HeroDoor
